module.exports = __webpack_public_path__ + "static/media/RP-A_S_Timeless_Sforza_Orange.4f9464b4.png";